import { render, staticRenderFns } from "./news-and-media-list-tab-page.vue?vue&type=template&id=f5fac4f0&scoped=true"
import script from "./news-and-media-list-tab-page.vue?vue&type=script&lang=js"
export * from "./news-and-media-list-tab-page.vue?vue&type=script&lang=js"
import style0 from "./news-and-media-list-tab-page.vue?vue&type=style&index=0&id=f5fac4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fac4f0",
  null
  
)

export default component.exports